import {HttpInterceptorFn} from '@angular/common/http';
import {finalize} from "rxjs";
import {inject} from "@angular/core";
import {LoadingService} from "@services/loading.service";
import {SKIP_LOADING_CONTEXT} from "@/app/app.config";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    // Проверяем, нужно ли пропустить этот запрос (см. Шаг 5)
    const skipLoading = req.context.get(SKIP_LOADING_CONTEXT);

    if (skipLoading) {
        return next(req);
    }

    const loadingService = inject(LoadingService);
    loadingService.show();

    return next(req).pipe(
        finalize(() => {
            loadingService.hide();
        })
    );
};
